export const LOCAL_STORAGE_DEVICEID = "device-id";
export const LOCAL_STORAGE_AUTHTOKEN = "auth-token";
export const LOCAL_STORAGE_REFRESHTOKEN = "refresh-token";
export const LOCAL_STORAGE_RENEWTOKEN_STATUS = "refresh-token-status";
export const LOCAL_STORAGE_LOCALE = "app-locale";
export const LOCAL_STORAGE_TWILIOTOKEN = "twilio-token";
export const LOCAL_STORAGE_MAP_LATLONG = "map-latlng";
export const LOCAL_STORAGE_MAP_ZOOMLEVEL = "map-zoom";
